import React from "react";
import banner from "../../img/HopeAppliences/yellow-banner.png";

const Banner = () => {
  return (
    <div>
      <section className="mt-[44px] md:mt-20 mb-2 md:mb-24">
        <img src={banner} alt="" />
      </section>
    </div>
  );
};

export default Banner;
